module.exports = __webpack_public_path__ + "static/3-bb2059eae2205bacb3fc80600aa2c442.png";